import { Component, ElementRef, HostListener, inject, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MenuItem } from 'primeng/api';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { GuiUtils } from 'src/modules/utils/misc/gui-utils';
import { Utils } from 'src/modules/utils/shared/utils';
import { TableCellButton } from '../../models/table-cell-button.model';
import { TableCellEvent } from '../../models/table-cell-event.model';
import { TableCellType } from '../../models/table-cell-type.enum';
import { TableCell } from '../../models/table-cell.model';
import { TableColumn } from '../../models/table-column.model';
import { TableRow } from '../../models/table-row.model';
import { ObjectActionWithObject } from '../../shared/object-action-with-object.model';
import { ObjectAction } from '../../shared/object-action.model';
import { SmTable2Component } from '../sm-table2/sm-table2.component';

@Component({
  selector: 'sm-table-cell2',
  templateUrl: './sm-table-cell2.component.html',
  styleUrl: './sm-table-cell2.component.scss'
})
  export class SmTableCell2Component implements ICellRendererAngularComp {

    static globalActions: ObjectAction[] = [];

    _Utils = Utils;
    _TableCellType = TableCellType;

    app = inject(MainAppService);

    column: TableColumn;
    parentTable: SmTable2Component;
    params: any;
    mouseInside = false;

    @ViewChild("value", {read: ElementRef})
    value: ElementRef;

    agInit(params: any): void {
        this.params = params;
        this.column = this.params.colDef.context.tableColumn;
        this.parentTable = this.params.colDef.context.table;
    }

    refresh(params: any): boolean {
        this.agInit(params);
        return true;
    }

    getTableCell(): TableCell {
        let v = this.params.data.values[this.column.id];
        return v instanceof TableCell ? v : null;
    }

    getKeepHtml(): boolean {
        return this.getTableCell()?.keepHtml;
    }

    buttonClick(event: any, button: TableCellButton): void {
        if (this.column.id == SmTable2Component.COLUMN_ID_REMOVE) {
            this.parentTable.removeRow(this.params.data as TableRow, true);
        }
        else if (this.column.id == SmTable2Component.COLUMN_ID_EDIT_ROW_FULL_SCREEN) {
            this.parentTable.editRowFullScreen(this.params.node);
        }
        else {
            this.parentTable.onCellClicked.emit(new TableCellEvent(button, this.params.data as TableRow, this.params.colDef, 0, 0));
        }
    }

    getObjectActions(): ObjectActionWithObject[] {
        let s = Utils.toString(this.params.value);
        return [
            new ObjectActionWithObject({
                getCaption: () => "In Zwischenablage kopieren",
                isUsable: value => Utils.isString(value),
                perform: async value => {
                    await GuiUtils.copyToClipboard(value as string);
                    return null;
                }
            }, s),
            new ObjectActionWithObject({
                getCaption: () => "Text in Fenster öffnen",
                isUsable: value => Utils.isString(value),
                perform: value => {
                    this.app.messageDialog.textArea("Zellentext", value as string, null, true);
                    return null;
                }
            }, s),
            new ObjectActionWithObject({
                getCaption: () => "Texte dieser Spalte in Fenster öffnen",
                isUsable: _ => true,
                perform: _ => {
                    this.app.messageDialog.textArea("Spaltenwerte", Utils.arrayItemsToString(this.parentTable.getUnfilteredRows(), "\n", row => TableCell.getValue(row.values[this.params.colDef.colId as string])), null, true);
                    return null;
                }
            }, s),
            new ObjectActionWithObject({
                getCaption: () => "Nur Zeilen mit diesem Wert anzeigen",
                isUsable: _ => this.parentTable.allowFilter,
                perform: (value) => {
                    this.parentTable.setFilter(this.params.colDef.colId as string, value);
                    return null;
                }
            }, s),
            ...SmTableCell2Component.globalActions.map(a => new ObjectActionWithObject(a, s)),
            ...this.getTableCell()?.internal == null || this.getTableCell()?.actionProviders == null ? [] :
                Utils.arrayExplode(this.getTableCell().actionProviders, ap => Utils.arrayExplode(this.getTableCell().internal, key => ap.getActions(key).map(a => new ObjectActionWithObject(a, key))))
        ];
    }

    actionButtonClick(event: any): void {
        let menu: MenuItem[] = this.getObjectActions().filter(a => a.action.isUsable(a.on)).map(a => ({
            label: a.action.getCaption(a.on),
            icon: "fas fa-open",
            command: async _ => a.action.perform(a.on)
        }));
        this.app.openContextMenu(menu);
        event.preventDefault();
        event.stopPropagation();
    }

    @HostListener('mouseenter')
    mouseEnter(): void {
        this.mouseInside = true;
    }

    @HostListener('mouseleave')
    mouseLeave(): void {
        this.mouseInside = false;
    }

    addRow(): void {
        this.parentTable.addRow();
    }

    handleTooltip(event: any): void {
        const element = event.element;
        element.setAttribute('title', Utils.toString(this.params.valueFormatted));
    }

  }
